module.exports = __webpack_public_path__ + "static/low-conversation-rate-b2737d9f0ba67a8a5e0c480b8af27ab1.png";